<template>
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block"
       @click.self="close"
       @keyup.esc="close">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content shadow-lg border-0">
        <div class="modal-header border-0 px-4 bg-primary-light">
          <h5 class="modal-title">What's New in Mantiq</h5>
          <button @click="close" type="button" class="btn-close"></button>
        </div>
        <div class="modal-body p-0">
          <!-- 1.4 -->
          <details class="p-3" open>
            <summary class="d-flex align-items-center">September 2022 <span
                class="badge rounded-pill bg-dark ms-auto px-2 fw-normal">Version 1.4</span>
            </summary>
            <div class="mt-3 p-3 rounded border bg-primary-light">
              <h5>New: Templates</h5>
              <p class="m-0">Get started in no time thanks to a set of prebuilt, bundeled workflows.</p>
            </div>
            <div class="mt-3 p-3 rounded border">
              <h5>Other changes</h5>
              <ul class="small m-0 px-3">
                <li>Triggers API updated to allow filtering and custom setup.</li>
                <li>The user interface has been rearranged to provide intuitive experience.</li>
              </ul>
            </div>
          </details>
          <!-- 1.3 -->
          <details class="p-3 border-top">
            <summary class="d-flex align-items-center">August 2022<span
                class="badge rounded-pill bg-dark ms-auto px-2 fw-normal">Version 1.3</span>
            </summary>
            <div class="mt-3 p-3 rounded border bg-primary-light">
              <h5>New action: HTTP Request</h5>
              <p class="m-0">A very useful action has been introduced: Execute an HTTP request.</p>
            </div>
            <div class="mt-3 p-3 rounded border">
              <h5>Other changes</h5>
              <ul class="small m-0 px-3">
                <li>Enhance "Send Email" action: set from, cc, bcc, reply to and more.</li>
                <li>The list of actions and events is now searchable.</li>
              </ul>
            </div>
          </details>
          <!-- 1.2 -->
          <details class="p-3 border-top">
            <summary class="d-flex align-items-center">December 2021 <span
                class="badge rounded-pill bg-dark ms-auto px-2 fw-normal">Version 1.2</span></summary>
            <div class="mt-3 p-3 rounded border bg-primary-light">
              <h5>Slack integration</h5>
              <p class="m-0">Send messages to your Slack channels, directly from Mantiq.</p>
              <a class="btn btn-sm btn-primary mt-2" href="https://wordpress.org/plugins/mantiq-integration-for-slack/"
                 target="_blank">Get Slack Integration</a>
            </div>
            <div class="mt-3 p-3 rounded border">
              <h5>Other changes</h5>
              <ul class="small m-0 px-3">
                <li>Improve workflow editor UX.</li>
                <li>Add integrations page.</li>
                <li>Fix some bugs in core actions.</li>
              </ul>
            </div>
          </details>
          <!-- 1.1 -->
          <details class="p-3 border-top">
            <summary class="d-flex align-items-center">November 2021 <span
                class="badge rounded-pill bg-dark ms-auto px-2 fw-normal">Version 1.1</span></summary>
            <div class="mt-3 p-3 rounded border bg-primary-light">
              <h5>WooCommerce integration</h5>
              <p class="m-0">Now you can automate your WooCommerce shop using different events and
                actions.</p>
              <a class="btn btn-sm btn-primary mt-2"
                 href="https://wordpress.org/plugins/mantiq-integration-for-woocommerce/" target="_blank">Get
                WooCommerce Integration</a>
            </div>
            <div class="mt-3 p-3 rounded border bg-primary-light">
              <h5>New utilities for developers</h5>
              <p class="m-0">Two new actions are available for developers: encode output as JSON string and write to
                log.</p>
            </div>
            <div class="mt-3 p-3 rounded border">
              <h5>Other changes</h5>
              <ul class="small m-0 px-3">
                <li>Improve underlaying APIs to support more use cases.</li>
                <li>Improve error messages.</li>
                <li>Fix some bugs in core actions.</li>
              </ul>
            </div>
          </details>
        </div>
      </div>
    </div>
  </div>


  <div hidden class="position-absolute top-0 end-0 bottom-0 start-0 bg-white" @keyup.esc="close">
    <button class="btn border btn-inline p-2 rounded-circle position-absolute top-0 end-0 m-3" @click="close">
      <span class="material-icons">close</span>
    </button>
    <div class="container p-5">
      <div class="row justify-content-center">
        <div class="col-8">
          <h3 class="mb-5 pb-3 border-bottom">What's New in Mantiq</h3>
          <h6 class="mb-3">November 2021</h6>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>New</strong></div>
            <div class="col">
              <p>WooCommerce integration. Now you can automate your WooCommerce shop using different events and
                actions.</p>
              <p>Filter log by type.</p>
              <p>Encode output as JSON string and write to log actions for developers.</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>Improvements</strong></div>
            <div class="col">
              <p>Underlaying APIs to enable more integrations and support more use cases.</p>
              <p>Error messages are more clear now.</p>
              <p>Encode output as JSON string and write to log actions for developers.</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-2 text-end border-end"><strong>Fixes</strong></div>
            <div class="col">
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useRouter} from "vue-router";

export default {
  name: "WhatsNew",
  setup() {
    const router = useRouter();

    const close = () => {
      router.push({path: '../'});
    };

    return {
      close,
    };
  }
}
</script>
